export const createDashboardModel = () => ({
  shippingPeriodsQuantities: [],
  filtersQuantities: [],

  basketsElapsed: '',
  groupsElapsed: '',
  queueElapsed: '',

  operations: [],
  machines: [],

  baskets: [],
  groups: [],
  queue: [],
});
